import {FILTERABLE_PARAM_PREFIX} from '../constants';

const isFilterableParam = (searchParam = '') =>
  searchParam.startsWith(FILTERABLE_PARAM_PREFIX);

export default isFilterableParam;
